import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const InfoIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.light,
  size = IconSize.small,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 14C9.58578 14 9.25 13.6642 9.25 13.25V10C9.25 9.58579 9.58578 9.25 10 9.25C10.4142 9.25 10.75 9.58578 10.75 10V13.25C10.75 13.6642 10.4142 14 10 14Z"
          fill={color}
        />
        <path
          d="M10 7.5C10.4142 7.5 10.75 7.16421 10.75 6.75C10.75 6.33578 10.4142 6 10 6C9.58578 6 9.25 6.33578 9.25 6.75C9.25 7.16421 9.58578 7.5 10 7.5Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 10C1 5.02943 5.02943 0.999999 10 0.999999C14.9706 0.999999 19 5.02943 19 10C19 14.9706 14.9706 19 10 19C5.02943 19 1 14.9706 1 10ZM10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
